import axios from './../../config/axios';

function create(data) {
    return axios().post("/purchase/goods-returns", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function get(id) {
    return axios().get(`/purchase/goods-returns/${id}`);
}

function update(id, data) {
    return axios().put(`/purchase/goods-returns/${id}`, data);
}

function remove(id) {
    return axios().delete(`/purchase/goods-returns/${id}`);
}

function post(id) {
    return axios().put(`/purchase/goods-returns/${id}/post`)
}

function list(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get(`/purchase/goods-returns`, { params })
}

export default {
    create,
    get,
    update,
    remove,
    list,
    post
}